export default __webpack_public_path__ + "static/PC_3_3_3-70972a4430fb3ae9bf77c440362574d7.png";